import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Grid,
  Row,
  Col
} from 'react-bootstrap';

import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './MoreSection.css';
//Image
import host1 from '../../../../public/MoreSection/1.jpg';
import host2 from '../../../../public/MoreSection/2.jpg';
import host3 from '../../../../public/MoreSection/3.jpg';

class SocialLogin extends Component {
  static propTypes = {
    formatMessage: PropTypes.any,
    refer: PropTypes.string,
    siteName: PropTypes.string.isRequired
  };

  render() {
    const { refer, siteName } = this.props;

    return (
      <Grid>
        <Row className={s.moresection}>
          <Col xs={12} sm={12} md={12} lg={12}>
            <Col xs={12} sm={12} md={12} lg={12}>
              <h3 className={s.mobilehead}>Más sobre ser anfitrión</h3>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className={s.moresblock}>
              <div className={s.mbimage} style={{ backgroundImage: `url(${host1})` }} >

              </div>
              <div className={s.mbcontent}>
                <a href="#">
                  <span className={s.hostheading}>Conecta con tus visitantes</span>
                  <span className={s.tagline}>Comparte lo mejor de tu territorio</span>
                </a>
              </div>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className={s.moresblock}>
              <div className={s.mbimage} style={{ backgroundImage: `url(${host2})` }}>

              </div>
              <div className={s.mbcontent}>
                <a href="#">
                  <span className={s.hostheading}>Administra tus reservas</span>
                  <span className={s.tagline}>Organiza tu disponibilidad fácilmente</span>
                </a>
              </div>
            </Col>
            <Col xs={12} sm={4} md={4} lg={4} className={s.moresblock}>
              <div className={s.mbimage} style={{ backgroundImage: `url(${host3})` }}>
              </div>
              <div className={s.mbcontent}>
                <a href="#">
                  <span className={s.hostheading}>Haz crecer tu experiencia</span>
                  <span className={s.tagline}>Recibe viajeros que buscan algo especial</span>
                </a>
              </div>
            </Col>
          </Col>
        </Row>
      </Grid>
    );
  }
}

const mapState = state => ({
  siteName: state.siteSettings.data.siteName

});

const mapDispatch = {};

export default withStyles(s)(connect(mapState, mapDispatch)(SocialLogin));
